(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        // $httpProvider.interceptors.push('secureHttpInterceptor');

        $stateProvider
            .state('admin', {
                url: "/:langcode/management",
                templateUrl: 'app/admin/admin.content.html',
                controller: 'AdminController',
                abstract: true,
                resolve: {
                    // Lazy load admin bundle - replaces old lazyLoad function
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'admin');
                    }],
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90, 100]);
                        }
                    ],
                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_account');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.membership-list', {
                url: '/user?page',
                templateUrl: 'app/admin/admin.membership-list.html',
                controller: 'MembershipListController'
            })
            .state('admin.membership-detail', {
                url: '/user/:id',
                templateUrl: 'app/admin/admin.membership-detail.html',
                controller: 'MembershipDetailController'
            })
            .state('admin.company-list', {
                url: '/company',
                templateUrl: 'app/admin/admin.company-list.html',
                controller: 'CompanyListController'
            })
            .state('admin.company-create', {
                url: '/company/update?id',
                templateUrl: 'app/admin/admin.company-create.html',
                controller: 'CompanyCreateController',
                params: {
                    id: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                }
            })
            .state('admin.feature-access-list', {
                url: '/feature-access?page',
                templateUrl: 'app/admin/admin.feature-access-list.html',
                controller: 'FeatureAccessListController'
            })
            .state('admin.promo-list', {
                url: '/promo',
                templateUrl: 'app/admin/admin.promo-list.html',
                controller: 'CompanyPromoController'
            })
            .state('admin.promo-create', {
                url: '/promo/create?id',
                templateUrl: 'app/admin/admin.promo-create.html',
                controller: 'CompanyPromoCreateController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([30, 50, 70, 80, 90]);
                        }
                    ]
                }
            })
            .state('admin.consultant-create', {
                url: '/consultant/create',
                templateUrl: 'app/admin/admin.consultant-create.html',
                controller: 'AdminConsultantCreateController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([25, 30, 50, 70, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.order-list', {
                url: '/order?userId?page',
                templateUrl: 'app/admin/admin.order-list.html',
                controller: 'AdminOrderListController',
                params: {
                    userId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.consultant-list', {
                url: '/consultant?userId',
                templateUrl: 'app/admin/admin.consultant-list.html',
                controller: 'AdminConsultantListController',
                params: {
                    userId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.agent-segmentation-list', {
                url: '/segment',
                templateUrl: 'app/admin/admin.agent-segmentation-list.html',
                controller: 'AdminAgentSegmentationListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([25, 30, 50, 80, 90]);
                        }
                    ]
                }
            })
            .state('admin.agent-segmentation-detail', {
                url: '/segment?agentId',
                templateUrl: 'app/admin/admin.agent-segmentation-detail.html',
                controller: 'AdminAgentSegmentationDetailController',
                params: {
                    agentId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([25, 30, 50, 80, 90]);
                        }
                    ]
                }
            })
            .state('admin.comment-list', {
                url: '/comment',
                templateUrl: 'app/admin/admin.comment-list.html',
                controller: 'AdminCommentListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50]);
                        }
                    ]
                }
            })
            .state('admin.comment-detail', {
                url: '/comment?id',
                templateUrl: 'app/admin/admin.comment-detail.html',
                controller: 'AdminCommentDetailController',
                params: {
                    id: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50]);
                        }
                    ]
                }
            })
            .state('admin.renta-list', {
                url: '/renta',
                templateUrl: 'app/admin/admin.renta-list.html',
                controller: 'AdminRentaListController'
            })
            // .state('admin.lead-list', {
            //     url: '/lead',
            //     templateUrl: 'app/admin/admin.lead-list.html',
            //     controller: 'LeadListController'
            // })
            .state('admin.order-create', {
                url: '/order/create?userId&renewal',
                templateUrl: 'app/admin/admin.order-create.html',
                controller: 'AdminOrderCreateController',
                params: {
                    userId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    },
                    renewal: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                }
            })
            .state('admin.order-detail', {
                url: '/order/detail/:id',
                templateUrl: 'app/admin/admin.order-detail.html',
                controller: 'AdminOrderDetailController'
            })
            .state('admin.consultant-detail', {
                url: '/consultant/detail/:id',
                templateUrl: 'app/admin/admin.consultant-detail.html',
                controller: 'AdminConsultantDetailController'
            })
            .state('admin.payment-list', {
                url: '/payment?page',
                templateUrl: 'app/admin/admin.payment-list.html',
                controller: 'AdminPaymentListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([50, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.campaign-list', {
                url: '/campaign?page',
                templateUrl: 'app/admin/admin.campaign-list.html',
                controller: 'AdminCampaignListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90]);
                        }
                    ]
                }
            })

    }]);

})();
